"use client";

import { Modal } from "antd";
import base from "lib/base";
import { sanitizeHtml } from "lib/sanitize";
import styles from "styles/components/company-modal.module.css";

const resolveImage = (path) => {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  return `${base.cdnUrl}/${path}`;
};

/**
 * Unified Company Modal Component
 * @param {Object} props
 * @param {Object} props.company - Company data object
 * @param {boolean} props.open - Modal visibility state
 * @param {Function} props.onClose - Close handler
 */
const CompanyModal = ({ company, open, onClose }) => {
  if (!company) return null;

  const logo = resolveImage(company?.logo);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      destroyOnClose
      width={600}
      className={styles.modal}
    >
      <div className={styles.content}>
        <div className={styles.header}>
          {logo && (
            <div className={styles.logoWrap}>
              <img
                src={logo}
                alt={company?.name || "Company"}
                className={styles.logo}
              />
            </div>
          )}
          <div className={styles.titleBlock}>
            <div className={styles.name}>{company?.name || ""}</div>
          </div>
        </div>
        {company?.about ? (
          <div
            className={styles.about}
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(company.about),
            }}
          />
        ) : company?.shortAbout ? (
          <div
            className={styles.about}
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(company.shortAbout),
            }}
          />
        ) : null}
      </div>
    </Modal>
  );
};

export default CompanyModal;
